import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { ConversationControllerApi } from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  archive?: boolean;
  providerId?: string;
  participant2Provider?: boolean
  searchKey?: string;
  xTENANTID?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 * @author [Rajkumar Rathod]
 */
export const useGetAllConversation = ({
  pagination,
  gridSorting,
  archive,
  providerId,
  participant2Provider = true,
  searchKey,
  xTENANTID,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });
  const pageSize = getPageSize("", pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "conversation-list",
      pageIndex,
      pageSize,
      gridSorting,
      archive,
      providerId,
      participant2Provider,
      searchKey,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!xTENANTID,
    queryFn: async () =>
      await new ConversationControllerApi(getConfigObject())
        .getAllDepartments3(
          pageIndex,
          pageSize,
          sortBy,
          sortDirect,
          archive,
          providerId,
          participant2Provider,
          searchKey,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
